import * as React from 'react';
import { ClinicsContext } from './clinicsContext';
import clinicsReducer from './clinicsReducer';

export default function ClinicsProvider({ children }) {

  const [state, dispatch] = React.useReducer(clinicsReducer, {
    allClinics: [],
  })

  const value = [state, dispatch];

  return (
    <ClinicsContext.Provider value={ value }>
      { children }
    </ClinicsContext.Provider>
  )
}